{
  "id": "transparencia-snapshots",
  "nome": "Portal da Transparência endpoint registry",
  "fonte": "CGU Portal da Transparência — Swagger audit (query endpoints; no bulk embed in v1)",
  "endpoints": [
    "https://api.portaldatransparencia.gov.br/swagger-ui/index.html",
    "https://api.portaldatransparencia.gov.br/v3/api-docs",
    "https://portaldatransparencia.gov.br/"
  ],
  "capturadoEm": "2026-08-11",
  "atualizadoEm": "2026-08-11T06:09:41.182Z",
  "contagens": {
    "endpoints": 8,
    "queryAdapter": 7
  },
  "alteracoes": {
    "adicionados": 0,
    "removidos": 0,
    "alterados": 0,
    "comparadoCom": "2026-08-05"
  },
  "verificacao": {
    "agendamento": "diario",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-08-11T06:09:41.182Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#portal-transparencia"
}
